/**
 * Macmerise Checkout Popup
 * Intercepts checkout flow and collects phone, OTP, and address
 * before redirecting to Shopify checkout with pre-filled data.
 *
 * @version 2.0.0
 */
(function() {
  'use strict';

  var CONFIG = window.__mcCheckoutConfig || {};
  var API = CONFIG.apiBase || '';

  /* ========================================================================
     Country / ZIP Mappings
     ======================================================================== */

  var PHONE_TO_COUNTRY = {
    '+91': { code: 'IN', name: 'India', flag: '\uD83C\uDDEE\uD83C\uDDF3' },
    '+1': { code: 'US', name: 'United States', flag: '\uD83C\uDDFA\uD83C\uDDF8' },
    '+44': { code: 'GB', name: 'United Kingdom', flag: '\uD83C\uDDEC\uD83C\uDDE7' },
    '+971': { code: 'AE', name: 'UAE', flag: '\uD83C\uDDE6\uD83C\uDDEA' },
    '+65': { code: 'SG', name: 'Singapore', flag: '\uD83C\uDDF8\uD83C\uDDEC' },
    '+61': { code: 'AU', name: 'Australia', flag: '\uD83C\uDDE6\uD83C\uDDFA' },
    '+49': { code: 'DE', name: 'Germany', flag: '\uD83C\uDDE9\uD83C\uDDEA' },
    '+33': { code: 'FR', name: 'France', flag: '\uD83C\uDDEB\uD83C\uDDF7' },
    '+81': { code: 'JP', name: 'Japan', flag: '\uD83C\uDDEF\uD83C\uDDF5' },
    '+82': { code: 'KR', name: 'South Korea', flag: '\uD83C\uDDF0\uD83C\uDDF7' },
    '+60': { code: 'MY', name: 'Malaysia', flag: '\uD83C\uDDF2\uD83C\uDDFE' },
    '+64': { code: 'NZ', name: 'New Zealand', flag: '\uD83C\uDDF3\uD83C\uDDFF' },
    '+966': { code: 'SA', name: 'Saudi Arabia', flag: '\uD83C\uDDF8\uD83C\uDDE6' },
    '+974': { code: 'QA', name: 'Qatar', flag: '\uD83C\uDDF6\uD83C\uDDE6' }
  };

  var ZIP_RULES = {
    'IN': { required: true, maxlength: 6, inputmode: 'numeric', pattern: '[0-9]{6}', placeholder: '400001', label: 'Pincode', hasLookup: true },
    'US': { required: true, maxlength: 5, inputmode: 'numeric', pattern: '[0-9]{5}', placeholder: '10001', label: 'ZIP Code', hasLookup: false },
    'GB': { required: true, maxlength: 8, inputmode: 'text', pattern: '', placeholder: 'SW1A 1AA', label: 'Postcode', hasLookup: false },
    'SA': { required: true, maxlength: 5, inputmode: 'numeric', pattern: '[0-9]{5}', placeholder: '12345', label: 'Postal Code', hasLookup: false },
    'AE': { required: false, maxlength: 5, inputmode: 'numeric', pattern: '', placeholder: '00000 (optional)', label: 'Postal Code', hasLookup: false },
    'QA': { required: false, maxlength: 10, inputmode: 'text', pattern: '', placeholder: 'Postal code (optional)', label: 'Postal Code', hasLookup: false },
    'DEFAULT': { required: false, maxlength: 10, inputmode: 'text', pattern: '', placeholder: 'Postal code (optional)', label: 'Postal Code', hasLookup: false }
  };

  function getSessionInfo() {
    try {
      var match = document.cookie.match(/(?:^|;\s*)mc_session_info=([^;]*)/)
      if (!match || !match[1]) return null
      return JSON.parse(decodeURIComponent(match[1]))
    } catch (e) {
      return null
    }
  }

  /* ========================================================================
     State
     ======================================================================== */

  var _sessionInfo = getSessionInfo()
  var _legacyToken = localStorage.getItem('mc_session_token')

  var state = {
    currentStep: 'phone',
    sessionId: null,
    sessionToken: _sessionInfo ? 'cookie' : (_legacyToken || null),
    phone: (_sessionInfo ? _sessionInfo.phone : null) || localStorage.getItem('mc_session_phone') || null,
    countryCode: '+91',
    selectedAddressId: null,
    addressLabel: 'Home',
    addresses: [],
    resendTimerId: null,
    whatsappTimerId: null,
    sendingOtp: false,
    intlCart: null,
    intlCartOriginalItems: null,
    intlRzOrderId: null,
    intlPollingTimer: null,
    isInternational: false
  };

  /* ========================================================================
     DOM References
     ======================================================================== */

  var dom = {};

  function cacheDom() {
    dom.popup = document.getElementById('mc-checkout-popup');
    dom.sheet = dom.popup.querySelector('.mc-popup__sheet');
    dom.backdrop = document.getElementById('mc-backdrop');
    dom.backBtn = document.getElementById('mc-back-btn');

    // Steps
    dom.stepPhone = document.getElementById('mc-step-phone');
    dom.stepOtp = document.getElementById('mc-step-otp');
    dom.stepAddress = document.getElementById('mc-step-address');

    // Progress bar
    dom.progressSteps = document.querySelectorAll('.mc-progress__step');

    // Phone
    dom.countryCode = document.getElementById('mc-country-code');
    dom.phoneInput = document.getElementById('mc-phone-input');
    dom.phoneSubmit = document.getElementById('mc-phone-submit');
    dom.phoneError = document.getElementById('mc-phone-error');

    // OTP
    dom.otpPhoneDisplay = document.getElementById('mc-otp-phone-display');
    dom.otpInputs = document.getElementById('mc-otp-inputs');
    dom.otpDigits = dom.otpInputs.querySelectorAll('.mc-otp-input');
    dom.otpSubmit = document.getElementById('mc-otp-submit');
    dom.otpError = document.getElementById('mc-otp-error');
    dom.resendBtn = document.getElementById('mc-resend-btn');
    dom.editPhoneBtn = document.getElementById('mc-edit-phone-btn');
    dom.whatsappBtn = document.getElementById('mc-whatsapp-btn');

    // Address form fields
    dom.country = document.getElementById('mc-country');
    dom.pincodeLabel = document.getElementById('mc-pincode-label');
    dom.addressSave = document.getElementById('mc-address-save');
    dom.addressError = document.getElementById('mc-address-error');
    dom.pincode = document.getElementById('mc-pincode');
    dom.pincodeStatus = document.getElementById('mc-pincode-status');
    dom.address1 = document.getElementById('mc-address1');
    dom.city = document.getElementById('mc-city');
    dom.state = document.getElementById('mc-state');
    dom.addrPhone = document.getElementById('mc-addr-phone');
    dom.addrPhoneFlag = document.getElementById('mc-addr-phone-flag');
    dom.addrPhoneCode = document.getElementById('mc-addr-phone-code');
    dom.fullName = document.getElementById('mc-full-name');
    dom.email = document.getElementById('mc-email');
    dom.saveTags = document.getElementById('mc-save-tags');
    dom.addressGeo = document.getElementById('mc-address-geo');
    dom.geoText = document.getElementById('mc-geo-text');
    dom.geoLabel = document.getElementById('mc-geo-label');
    dom.geoGroup = document.getElementById('mc-geo-group');
    dom.cityStateFields = document.getElementById('mc-city-state-fields');

    // Address card list (logged-in)
    dom.stepAddressCard = document.getElementById('mc-step-address-card');
    dom.addrList = document.getElementById('mc-addr-list');
    dom.addrAddBtn = document.getElementById('mc-addr-add-btn');
    dom.cardCheckout = document.getElementById('mc-card-checkout');
    dom.cardError = document.getElementById('mc-card-error');

    // International checkout steps
    dom.stepIntlCart = document.getElementById('mc-step-intl-cart');
    dom.stepIntlProcessing = document.getElementById('mc-step-intl-processing');
    dom.stepIntlConfirmed = document.getElementById('mc-step-intl-confirmed');
    dom.intlCurrencyLabel = document.getElementById('mc-intl-currency-label');
    dom.intlCartItems = document.getElementById('mc-intl-cart-items');
    dom.intlSubtotal = document.getElementById('mc-intl-subtotal');
    dom.intlShipping = document.getElementById('mc-intl-shipping');
    dom.intlTotal = document.getElementById('mc-intl-total');
    dom.intlPayBtn = document.getElementById('mc-intl-pay-btn');
    dom.intlPayAmount = document.getElementById('mc-intl-pay-amount');
    dom.intlProcessingText = document.getElementById('mc-intl-processing-text');
    dom.intlOrderName = document.getElementById('mc-intl-order-name');
    dom.intlContinueBtn = document.getElementById('mc-intl-continue-btn');

    // Footer
    dom.checkoutBtn = document.getElementById('mc-checkout-btn');
    dom.sessionInfo = document.getElementById('mc-session-info');
    dom.sessionPhone = document.getElementById('mc-session-phone');
    dom.logoutBtn = document.getElementById('mc-logout-btn');
  }

  /* ========================================================================
     API Helpers
     ======================================================================== */

  function apiCall(endpoint, options) {
    var opts = options || {};
    var headers = { 'Content-Type': 'application/json' };

    // Only set Bearer header for legacy localStorage tokens (migration compat)
    if (state.sessionToken && state.sessionToken !== 'cookie') {
      headers['Authorization'] = 'Bearer ' + state.sessionToken;
    }

    var fetchOpts = Object.assign({}, opts, {
      headers: Object.assign({}, headers, opts.headers || {}),
      credentials: 'include'
    });

    return fetch(API + endpoint, fetchOpts)
      .then(function(res) {
        return res.json().then(function(data) {
          if (!res.ok) {
            throw new Error(data.debug || data.error || 'Request failed');
          }
          return data;
        });
      });
  }

  /**
   * The shopper's cart token, which doubles as the Storefront API cart id and
   * lets the backend prefill checkout without rebuilding the cart. Resolves to
   * null on failure — checkout still proceeds, just unprefilled.
   */
  function getCartToken() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function(res) { return res.ok ? res.json() : null; })
      .then(function(cart) { return (cart && cart.token) || null; })
      .catch(function() { return null; });
  }

  /* ========================================================================
     Error Display
     ======================================================================== */

  function showError(el, message) {
    el.textContent = message;
    el.hidden = false;
  }

  function hideError(el) {
    el.textContent = '';
    el.hidden = true;
  }

  /* ========================================================================
     Button Loading
     ======================================================================== */

  function setButtonLoading(btn, loading, loadingText) {
    if (loading) {
      btn.dataset.originalText = btn.textContent;
      btn.textContent = loadingText || 'Please wait...';
      btn.disabled = true;
    } else {
      btn.textContent = btn.dataset.originalText || btn.textContent;
      btn.disabled = false;
    }
  }

  /* ========================================================================
     Step Management
     ======================================================================== */

  var STEP_ORDER = ['phone', 'otp', 'address'];

  function goToStep(stepName) {
    state.currentStep = stepName;

    // Hide all steps
    dom.stepPhone.hidden = true;
    dom.stepOtp.hidden = true;
    dom.stepAddress.hidden = true;
    dom.stepAddressCard.hidden = true;
    dom.stepIntlCart.hidden = true;
    dom.stepIntlProcessing.hidden = true;
    dom.stepIntlConfirmed.hidden = true;

    // Show target step
    var targetEl = {
      phone: dom.stepPhone,
      otp: dom.stepOtp,
      address: dom.stepAddress,
      'address-card': dom.stepAddressCard,
      'intl-cart': dom.stepIntlCart,
      'intl-processing': dom.stepIntlProcessing,
      'intl-confirmed': dom.stepIntlConfirmed
    }[stepName];

    if (targetEl) {
      targetEl.hidden = false;
    }

    // Back button always visible (except during processing)
    dom.backBtn.hidden = (stepName === 'intl-processing');

    // Hide progress bar for international steps
    var isIntlStep = stepName.indexOf('intl-') === 0;
    var progressEl = document.getElementById('mc-progress');
    if (progressEl) {
      progressEl.hidden = isIntlStep;
    }

    // Update progress bar for non-international steps
    if (!isIntlStep) {
      var progressStep = (stepName === 'address-card') ? 'address' : stepName;
      updateProgressBar(progressStep);
    }

    // Hide footer checkout button (handled by inline buttons)
    dom.checkoutBtn.hidden = true;

    // Show/hide session info
    var showSession = (stepName === 'address' || stepName === 'address-card') && state.sessionToken;
    dom.sessionInfo.hidden = !showSession;

    // Hide order total header for international steps (cart summary is shown inline)
    var orderToggle = document.getElementById('mc-order-toggle');
    if (orderToggle) {
      orderToggle.style.visibility = isIntlStep ? 'hidden' : 'visible';
    }
  }

  function updateProgressBar(stepName) {
    var currentIndex = STEP_ORDER.indexOf(stepName);
    dom.progressSteps.forEach(function(step, i) {
      step.classList.remove('mc-progress__step--active', 'mc-progress__step--completed');
      if (i < currentIndex) {
        step.classList.add('mc-progress__step--completed');
      } else if (i === currentIndex) {
        step.classList.add('mc-progress__step--active');
      }
    });
  }

  /* ========================================================================
     Focus Trap
     ======================================================================== */

  function trapFocus(e) {
    if (e.key !== 'Tab' || dom.popup.hidden) return;
    var focusable = dom.sheet.querySelectorAll(
      'button:not([hidden]):not([disabled]), input:not([hidden]):not([disabled]), select:not([hidden]):not([disabled]), a[href]:not([hidden])'
    );
    if (focusable.length === 0) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  /* ========================================================================
     Popup Open / Close
     ======================================================================== */

  function loadOrderSummary() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var amountEl = document.getElementById('mc-order-amount');
        var itemsEl = document.getElementById('mc-order-items');
        var totalsEl = document.getElementById('mc-order-totals');
        if (!amountEl) return;

        var total = (cart.total_price / 100).toLocaleString('en-IN', { style: 'currency', currency: cart.currency });
        amountEl.textContent = total;

        var compareTotal = cart.items.reduce(function(sum, item) {
          return sum + (item.compare_at_price || item.original_price) * item.quantity;
        }, 0);
        if (compareTotal > cart.total_price) {
          var compareStr = (compareTotal / 100).toLocaleString('en-IN', { style: 'currency', currency: cart.currency });
          amountEl.innerHTML = '<span style="text-decoration:line-through;color:var(--mc-mist);font-size:12px;font-weight:400">' + compareStr + '</span> ' + total;
        }

        var itemsHtml = cart.items.map(function(item) {
          var img = item.featured_image ? item.featured_image.url + '&width=96' : '';
          var variant = item.variant_title || '';
          var price = (item.final_line_price / 100).toLocaleString('en-IN', { style: 'currency', currency: cart.currency });
          return '<div class="mc-order-summary__item">' +
            (img ? '<img class="mc-order-summary__item-img" src="' + escapeAttr(img) + '" alt="">' : '') +
            '<div class="mc-order-summary__item-info">' +
              '<div class="mc-order-summary__item-title">' + escapeHtml(item.product_title) + '</div>' +
              (variant ? '<div class="mc-order-summary__item-variant">' + escapeHtml(variant) + '</div>' : '') +
              (item.quantity > 1 ? '<div class="mc-order-summary__item-qty">Qty: ' + item.quantity + '</div>' : '') +
            '</div>' +
            '<div class="mc-order-summary__item-price">' + price + '</div>' +
          '</div>';
        }).join('');
        itemsEl.innerHTML = itemsHtml;

        totalsEl.innerHTML = '<span>Total</span><span>' + total + '</span>';
      });
  }

  function initOrderToggle() {
    var toggle = document.getElementById('mc-order-toggle');
    var summary = document.getElementById('mc-order-summary');
    if (!toggle || !summary) return;
    toggle.setAttribute('aria-expanded', 'false');
    toggle.addEventListener('click', function() {
      var expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!expanded));
      summary.hidden = expanded;
    });
  }

  function openPopup(prevalidated) {
    // Close the cart drawer if it's open
    var cartDrawer = document.getElementById('cart-drawer');
    if (cartDrawer && typeof cartDrawer.hide === 'function') {
      cartDrawer.hide();
    }

    dom.popup.hidden = false;
    var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    document.body.style.paddingRight = scrollbarWidth + 'px';
    document.body.style.overflow = 'hidden';
    loadOrderSummary();

    if (prevalidated) {
      // Session already validated before opening — go straight to the right step
      // Hide progress bar since user skipped phone/OTP
      dom.progressSteps.forEach(function(step) { step.hidden = true; });

      if (state.addresses.length > 0) {
        var lastAddr = state.addresses[state.addresses.length - 1];
        state.selectedAddressId = lastAddr.id ? String(lastAddr.id) : null;
        renderAddressCards(state.addresses);
        goToStep('address-card');
        dom.sessionPhone.textContent = formatPhoneDisplay(lastAddr.phone_e164 || state.phone);
        dom.sessionInfo.hidden = false;
      } else {
        goToStep('address');
        prefillAddressForm(state.addresses);
        dom.sessionPhone.textContent = state.phone;
        dom.sessionInfo.hidden = false;
      }
    } else {
      // Restore progress bar visibility for normal flow
      dom.progressSteps.forEach(function(step) { step.hidden = false; });
      goToStep('phone');
      dom.phoneInput.value = '';
      hideError(dom.phoneError);
      dom.phoneInput.focus();
    }
  }

  // Triggered by checkout button click — validates session first if needed
  function handleCheckoutIntercept(triggerBtn) {
    // Re-check cookies in case user logged in via account dropdown after page load
    if (!state.sessionToken) {
      var freshInfo = getSessionInfo();
      if (freshInfo && freshInfo.logged_in) {
        state.sessionToken = 'cookie';
        state.phone = freshInfo.phone || '';
      }
    }

    if (!state.sessionToken) {
      openPopup(false);
      return;
    }

    // Add spinner to the clicked button
    if (triggerBtn) {
      triggerBtn.classList.add('mc-btn-loading');
      triggerBtn.disabled = true;
    }

    validateExistingSession().then(function(hasSession) {
      if (triggerBtn) {
        triggerBtn.classList.remove('mc-btn-loading');
        triggerBtn.disabled = false;
      }
      openPopup(hasSession);
    });
  }

  function closePopup() {
    dom.popup.hidden = true;
    document.body.style.paddingRight = '';
    document.body.style.overflow = '';
    clearCooldown('sms');
    clearCooldown('whatsapp');
    clearIntlPollingTimer();
  }

  /* ========================================================================
     Phone Step
     ======================================================================== */

  function validatePhone(phone) {
    var cleaned = phone.replace(/\D/g, '');
    if (state.countryCode === '+91') {
      return cleaned.length === 10 && /^[6-9]/.test(cleaned);
    }
    return cleaned.length >= 7 && cleaned.length <= 15;
  }

  function handlePhoneSubmit() {
    if (state.sendingOtp) return;
    var phone = dom.phoneInput.value.trim().replace(/\D/g, '');
    hideError(dom.phoneError);

    // Block leading zero
    if (state.countryCode === '+91' && phone.length > 0 && phone[0] === '0') {
      showError(dom.phoneError, 'Mobile numbers don\u2019t start with 0. Try without it.');
      return;
    }

    if (!validatePhone(phone)) {
      showError(dom.phoneError, 'Please enter a valid mobile number.');
      return;
    }

    state.sendingOtp = true;
    var fullPhone = state.countryCode + phone;

    dom.phoneSubmit.disabled = true;
    setButtonLoading(dom.phoneSubmit, true, 'Sending OTP...');

    apiCall('/api/otp/send', {
      method: 'POST',
      body: JSON.stringify({
        countryCode: state.countryCode,
        phone: phone,
        shopDomain: CONFIG.shopDomain
      })
    })
      .then(function(data) {
        setButtonLoading(dom.phoneSubmit, false);
        state.sessionId = data.sessionId;
        state.phone = fullPhone;

        // Show full phone for display
        dom.otpPhoneDisplay.textContent = state.countryCode + ' ' + phone;

        goToStep('otp');
        clearOTPInputs();
        dom.otpDigits[0].focus();
        setReady('sms');
        setReady('whatsapp');
        afterSend(data);
      })
      .catch(function(err) {
        setButtonLoading(dom.phoneSubmit, false);
        setTimeout(function() { dom.phoneSubmit.disabled = false; }, 3000);
        showError(dom.phoneError, err.message || 'Failed to send OTP. Please try again.');
      })
      .finally(function() { state.sendingOtp = false; });
  }

  /* ========================================================================
     OTP Step
     ======================================================================== */

  function initOTPInputs() {
    dom.otpDigits.forEach(function(input, i) {
      input.addEventListener('input', function(e) {
        var val = e.target.value.replace(/\D/g, '');
        e.target.value = val.slice(0, 1);
        if (val) {
          input.classList.add('mc-otp-input--filled');
        } else {
          input.classList.remove('mc-otp-input--filled');
        }
        if (val && i < dom.otpDigits.length - 1) {
          dom.otpDigits[i + 1].focus();
        }
      });

      input.addEventListener('keydown', function(e) {
        if (e.key === 'Backspace' && !e.target.value && i > 0) {
          dom.otpDigits[i - 1].focus();
        }
      });

      input.addEventListener('focus', function() {
        e_target_select(input);
      });
    });

    // Paste handling on all digits
    dom.otpDigits.forEach(function(input, i) {
      input.addEventListener('paste', function(e) {
        e.preventDefault();
        var clipboardData = e.clipboardData || window.clipboardData;
        var text = clipboardData.getData('text').replace(/\D/g, '').slice(0, 6 - i);
        text.split('').forEach(function(char, j) {
          if (dom.otpDigits[i + j]) {
            dom.otpDigits[i + j].value = char;
            if (char) {
              dom.otpDigits[i + j].classList.add('mc-otp-input--filled');
            }
          }
        });
        if (text.length > 0) {
          dom.otpDigits[Math.min(i + text.length, dom.otpDigits.length) - 1].focus();
        }
      });
    });
  }

  function e_target_select(input) {
    try { input.select(); } catch (_) { /* ignore */ }
  }

  function getOTPValue() {
    var code = '';
    dom.otpDigits.forEach(function(d) { code += d.value; });
    return code;
  }

  function clearOTPInputs() {
    dom.otpDigits.forEach(function(d) { d.value = ''; d.classList.remove('mc-otp-input--filled'); });
    hideError(dom.otpError);
  }

  function handleOTPSubmit() {
    var code = getOTPValue();
    hideError(dom.otpError);

    if (code.length !== 6) {
      showError(dom.otpError, 'Please enter the complete 6-digit code.');
      return;
    }

    setButtonLoading(dom.otpSubmit, true, 'Verifying...');

    apiCall('/api/otp/verify', {
      method: 'POST',
      body: JSON.stringify({
        sessionId: state.sessionId,
        otp: code,
        phone: state.phone,
        shopDomain: CONFIG.shopDomain
      })
    })
      .then(function(data) {
        setButtonLoading(dom.otpSubmit, false);
        clearCooldown('sms');
        clearCooldown('whatsapp');

        // JWT + cookies set by API response — mark session as cookie-based
        state.sessionToken = 'cookie';
        // Clean up legacy localStorage tokens
        localStorage.removeItem('mc_session_token');
        localStorage.removeItem('mc_session_phone');

        // Proceed to address step
        return handleCustomerLookup();
      })
      .catch(function(err) {
        setButtonLoading(dom.otpSubmit, false);
        showError(dom.otpError, err.message || 'Invalid OTP. Please try again.');
      });
  }

  // One cooldown per channel, so a WhatsApp send never locks or unlocks SMS
  // and the other way round. Outside India the default send goes on WhatsApp,
  // so the SMS link only says "SMS" for +91 numbers.
  var COOLDOWNS = {
    sms: {
      secs: 30, timer: 'resendTimerId', button: 'resendBtn',
      waiting: function() { return state.countryCode === '+91' ? 'Retry SMS in ' : 'Resend in '; },
      ready: function() { return state.countryCode === '+91' ? 'Resend SMS' : 'Resend code'; }
    },
    whatsapp: {
      secs: 45, timer: 'whatsappTimerId', button: 'whatsappBtn',
      waiting: function() { return 'Retry WhatsApp in '; },
      ready: function() { return 'Send on WhatsApp'; }
    }
  };

  // The WhatsApp button carries an icon: change only its text node. A plain
  // button (the SMS link, whose markup splits the text around a timer span)
  // gets its whole text replaced.
  function setLabel(btn, text) {
    if (!btn.querySelector('svg')) {
      btn.textContent = text;
      return;
    }
    for (var i = btn.childNodes.length - 1; i >= 0; i--) {
      var node = btn.childNodes[i];
      if (node.nodeType === 3 && node.nodeValue.trim()) {
        node.nodeValue = text;
        return;
      }
    }
    btn.appendChild(document.createTextNode(text));
  }

  function startCooldown(channel) {
    var c = COOLDOWNS[channel];
    var btn = dom[c.button];
    var seconds = c.secs;
    clearCooldown(channel);
    btn.disabled = true;

    function tick() {
      if (seconds <= 0) {
        setReady(channel);
        return;
      }
      setLabel(btn, c.waiting() + seconds + 's');
      seconds--;
    }

    tick();
    state[c.timer] = setInterval(tick, 1000);
  }

  function clearCooldown(channel) {
    var timer = COOLDOWNS[channel].timer;
    if (state[timer]) {
      clearInterval(state[timer]);
      state[timer] = null;
    }
  }

  function setReady(channel) {
    var c = COOLDOWNS[channel];
    clearCooldown(channel);
    dom[c.button].disabled = false;
    setLabel(dom[c.button], c.ready());
  }

  // The server reports the channel it actually used (an SMS that fails falls
  // back to WhatsApp), so the line and the cooldown follow `method`, not the
  // button the customer pressed.
  function afterSend(data) {
    var channel = data && data.method === 'whatsapp' ? 'whatsapp' : 'sms';
    var label = dom.otpPhoneDisplay.parentNode.previousSibling;
    if (label && label.nodeType === 3) {
      label.nodeValue = channel === 'whatsapp'
        ? 'Enter the 6-digit code sent on WhatsApp to '
        : 'Enter the 6-digit code sent by SMS to ';
    }
    startCooldown(channel);
    // Outside India the resend link also goes out on WhatsApp: hold it too,
    // or it would skip the WhatsApp wait.
    if (channel === 'whatsapp' && state.countryCode !== '+91') {
      startCooldown('sms');
    }
  }

  function handleResend() {
    clearOTPInputs();
    hideError(dom.otpError);
    setButtonLoading(dom.otpSubmit, true, 'Resending...');
    dom.resendBtn.disabled = true;

    apiCall('/api/otp/send', {
      method: 'POST',
      body: JSON.stringify({
        countryCode: state.countryCode,
        phone: state.phone.replace(state.countryCode, ''),
        shopDomain: CONFIG.shopDomain
      })
    })
      .then(function(data) {
        setButtonLoading(dom.otpSubmit, false);
        state.sessionId = data.sessionId;
        dom.otpDigits[0].focus();
        afterSend(data);
      })
      .catch(function(err) {
        setButtonLoading(dom.otpSubmit, false);
        setReady('sms');
        showError(dom.otpError, err.message || 'Failed to resend. Please try again.');
      });
  }

  function handleWhatsAppSend() {
    clearOTPInputs();
    hideError(dom.otpError);
    // Not setButtonLoading: it replaces textContent and would drop the icon.
    dom.whatsappBtn.disabled = true;
    setLabel(dom.whatsappBtn, 'Sending...');

    apiCall('/api/otp/send', {
      method: 'POST',
      body: JSON.stringify({
        countryCode: state.countryCode,
        phone: state.phone.replace(state.countryCode, ''),
        shopDomain: CONFIG.shopDomain,
        preferWhatsApp: true
      })
    })
      .then(function(data) {
        state.sessionId = data.sessionId;
        dom.otpDigits[0].focus();
        afterSend(data);
      })
      .catch(function(err) {
        setReady('whatsapp');
        showError(dom.otpError, err.message || 'Failed to send via WhatsApp.');
      });
  }

  /* ========================================================================
     Address Step
     ======================================================================== */

  function handleCustomerLookup() {
    return apiCall('/api/customer/lookup')
      .then(function(data) {
        state.addresses = data.addresses || [];

        // Update state.phone with full phone from address data (cookie has masked phone)
        var lastAddr = state.addresses.length > 0 ? state.addresses[state.addresses.length - 1] : null;
        if (lastAddr && lastAddr.phone_e164) {
          state.phone = lastAddr.phone_e164;
        }
        dom.sessionPhone.textContent = formatPhoneDisplay(state.phone);
        dom.sessionInfo.hidden = false;

        if (state.addresses.length > 0) {
          state.selectedAddressId = lastAddr.id ? String(lastAddr.id) : null;
          renderAddressCards(state.addresses);
          goToStep('address-card');
        } else {
          goToStep('address');
          prefillAddressForm(state.addresses);
        }
      })
      .catch(function(err) {
        showError(dom.otpError, err.message || 'Failed to load addresses.');
      });
  }

  function renderAddressCards(addresses) {
    dom.addrList.innerHTML = '';

    addresses.forEach(function(addr, index) {
      var tag = addr.label || 'Home';
      var name = ((addr.first_name || '') + ' ' + (addr.last_name || '')).trim();
      var parts = [addr.address1, addr.city, addr.state].filter(Boolean);
      var addressLine = parts.join(', ');
      var pincode = addr.pincode || addr.zip || '';
      var displayPhone = formatPhoneDisplay(addr.phone_e164 || state.phone || '');
      var email = addr.email || '';
      var addrId = addr.id ? String(addr.id) : '';
      var isSelected = addrId === state.selectedAddressId;

      var card = document.createElement('div');
      card.className = 'mc-addr-card' + (isSelected ? ' mc-addr-card--selected' : '');
      card.dataset.addressId = addrId;
      card.dataset.index = index;

      card.innerHTML =
        '<div class="mc-addr-card__header">' +
          '<div class="mc-addr-card__header-left">' +
            '<svg class="mc-addr-card__pin" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="10" r="3"/><path d="M12 21.7C17.3 17 20 13 20 10a8 8 0 1 0-16 0c0 3 2.7 7 8 11.7z"/></svg>' +
            '<span class="mc-addr-card__tag">' + escapeHtml(tag) + '</span>' +
          '</div>' +
          '<button type="button" class="mc-addr-card__edit" data-edit-index="' + index + '">' +
            'Edit <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>' +
          '</button>' +
        '</div>' +
        '<div class="mc-addr-card__body">' +
          '<p class="mc-addr-card__address"><strong>' + escapeHtml(name) + ',</strong> ' + escapeHtml(addressLine) + (pincode ? '  <strong>' + escapeHtml(pincode) + '</strong>' : '') + '</p>' +
          '<div class="mc-addr-card__meta">' +
            '<span class="mc-addr-card__meta-item">' +
              '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/></svg>' +
              '<span>' + escapeHtml(displayPhone) + '</span>' +
            '</span>' +
            (email ? '<span class="mc-addr-card__meta-item">' +
              '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="4" width="20" height="16" rx="2"/><path d="M22 7l-10 7L2 7"/></svg>' +
              '<span>' + escapeHtml(email) + '</span>' +
            '</span>' : '') +
          '</div>' +
        '</div>';

      dom.addrList.appendChild(card);
    });
  }

  function selectAddressCard(addrId) {
    state.selectedAddressId = addrId;
    var cards = dom.addrList.querySelectorAll('.mc-addr-card');
    cards.forEach(function(card) {
      card.classList.toggle('mc-addr-card--selected', card.dataset.addressId === addrId);
    });
  }

  function handleCardCheckout() {
    hideError(dom.cardError);

    if (!state.selectedAddressId) {
      showError(dom.cardError, 'No address selected. Please edit your address.');
      return;
    }

    // Check if selected address is international
    var selectedAddress = null;
    for (var i = 0; i < state.addresses.length; i++) {
      if (String(state.addresses[i].id) === state.selectedAddressId) {
        selectedAddress = state.addresses[i];
        break;
      }
    }

    if (selectedAddress && selectedAddress.country_code && selectedAddress.country_code !== 'IN') {
      state.isInternational = true;
      startInternationalCheckout(selectedAddress);
      return;
    }

    setButtonLoading(dom.cardCheckout, true, 'Preparing checkout...');

    getCartToken()
      .then(function(cartToken) {
        return apiCall('/api/checkout/prepare', {
          method: 'POST',
          body: JSON.stringify({ addressId: state.selectedAddressId, cartToken: cartToken })
        });
      })
      .then(function(data) {
        if (data.checkoutUrl) {
          window.location.href = data.checkoutUrl;
        } else {
          throw new Error('No checkout URL returned.');
        }
      })
      .catch(function(err) {
        setButtonLoading(dom.cardCheckout, false);
        showError(dom.cardError, err.message || 'Failed to prepare checkout. Please try again.');
      });
  }

  function handleCardEdit(index) {
    var idx = (typeof index === 'number') ? index : state.addresses.length - 1;
    var addr = state.addresses[idx] || null;
    goToStep('address');
    prefillAddressForm(addr ? [addr] : []);
  }

  function formatPhoneDisplay(phone) {
    if (!phone) return '';
    var cleaned = phone.replace(/[^\d+]/g, '');
    if (cleaned.startsWith('+91') && cleaned.length === 13) {
      return '+91 ' + cleaned.slice(3, 8) + ' ' + cleaned.slice(8);
    }
    return cleaned;
  }

  function getLocalPhone(phone) {
    if (!phone) return '';
    var cleaned = phone.replace(/[^\d+]/g, '');
    if (cleaned.startsWith('+91') && cleaned.length === 13) {
      var local = cleaned.slice(3);
      return local.slice(0, 5) + ' ' + local.slice(5);
    }
    return cleaned.replace(/^\+\d{1,4}/, '');
  }

  function prefillAddressForm(addresses) {
    resetAddressForm();

    // Determine the country to set on the form
    var addrCountry = null;
    if (addresses && addresses.length > 0) {
      addrCountry = addresses[addresses.length - 1].country_code || null;
    }

    // Fall back to phone code mapping if no country on address
    if (!addrCountry) {
      var phoneMapping = PHONE_TO_COUNTRY[state.countryCode];
      addrCountry = phoneMapping ? phoneMapping.code : 'IN';
    }

    dom.country.value = addrCountry;
    updateFormForCountry(addrCountry);

    // Pre-fill phone: prefer full phone from address data over masked session phone
    var addrPhone = (addresses && addresses.length > 0 && addresses[addresses.length - 1].phone_e164) || '';
    dom.addrPhone.value = getLocalPhone(addrPhone || state.phone);

    // Pre-fill from most recent address if available
    if (addresses && addresses.length > 0) {
      var addr = addresses[addresses.length - 1];
      dom.pincode.value = addr.pincode || addr.zip || '';
      dom.address1.value = addr.address1 || '';
      dom.city.value = addr.city || '';
      dom.state.value = addr.state || '';
      dom.email.value = addr.email || '';
      var name = ((addr.first_name || '') + ' ' + (addr.last_name || '')).trim();
      dom.fullName.value = name;

      var countryRules = ZIP_RULES[addrCountry] || ZIP_RULES['DEFAULT'];
      if (countryRules.hasLookup && addr.city && addr.state) {
        showLocation(addr.state, addr.city);
      }

      if (addr.label) {
        setActiveTag(addr.label);
      }
    }

    dom.pincode.focus();
  }

  function resetAddressForm() {
    dom.country.value = 'IN';
    dom.pincode.value = '';
    dom.address1.value = '';
    dom.city.value = '';
    dom.state.value = '';
    dom.addrPhone.value = '';
    dom.fullName.value = '';
    dom.email.value = '';
    dom.pincodeStatus.textContent = '';
    dom.geoGroup.hidden = false;
    dom.geoLabel.textContent = 'Choose State, City | India';
    dom.cityStateFields.hidden = true;
    // Reset pincode field to India defaults
    dom.pincodeLabel.innerHTML = 'Pincode <span class="mc-required">*</span>';
    dom.pincode.setAttribute('maxlength', '6');
    dom.pincode.setAttribute('inputmode', 'numeric');
    dom.pincode.setAttribute('placeholder', '400001');
    dom.pincode.setAttribute('pattern', '[0-9]{6}');
    updateAddrPhoneDisplay('IN');
    setActiveTag('Home');
    hideError(dom.addressError);
  }

  function showLocation(stateName, cityName) {
    dom.geoLabel.textContent = cityName + ', ' + stateName;
    dom.geoText.classList.add('mc-location-left--active');
    dom.geoGroup.hidden = false;
    dom.cityStateFields.hidden = true;
  }

  function setActiveTag(tagName) {
    state.addressLabel = tagName;
    var tags = dom.saveTags.querySelectorAll('.mc-tag');
    tags.forEach(function(tag) {
      tag.classList.toggle('mc-tag--active', tag.dataset.tag === tagName);
    });
  }

  function updateFormForCountry(countryCode) {
    var rules = ZIP_RULES[countryCode] || ZIP_RULES['DEFAULT'];

    // Update pincode label
    var requiredSpan = rules.required ? ' <span class="mc-required">*</span>' : '';
    dom.pincodeLabel.innerHTML = rules.label + requiredSpan;

    // Update pincode input attributes
    dom.pincode.setAttribute('maxlength', rules.maxlength);
    dom.pincode.setAttribute('inputmode', rules.inputmode);
    dom.pincode.setAttribute('placeholder', rules.placeholder);
    if (rules.pattern) {
      dom.pincode.setAttribute('pattern', rules.pattern);
    } else {
      dom.pincode.removeAttribute('pattern');
    }

    // Clear pincode value and status when country changes
    dom.pincode.value = '';
    dom.pincodeStatus.textContent = '';

    if (rules.hasLookup) {
      // India: show geo-lookup group, hide manual city/state fields
      dom.geoGroup.hidden = false;
      dom.geoLabel.textContent = 'Choose State, City | India';
      dom.geoText.classList.remove('mc-location-left--active');
      dom.cityStateFields.hidden = true;
    } else {
      // Non-India: hide geo-lookup, show city/state fields directly
      dom.geoGroup.hidden = true;
      dom.cityStateFields.hidden = false;
    }

    // Update the address phone display to match the selected country
    updateAddrPhoneDisplay(countryCode);
  }

  function updateAddrPhoneDisplay(countryCode) {
    // Find matching phone code for country code
    var matchedPhone = null;
    var keys = Object.keys(PHONE_TO_COUNTRY);
    for (var i = 0; i < keys.length; i++) {
      if (PHONE_TO_COUNTRY[keys[i]].code === countryCode) {
        matchedPhone = { phoneCode: keys[i], info: PHONE_TO_COUNTRY[keys[i]] };
        break;
      }
    }

    if (matchedPhone && dom.addrPhoneFlag && dom.addrPhoneCode) {
      dom.addrPhoneFlag.textContent = matchedPhone.info.flag;
      dom.addrPhoneCode.textContent = matchedPhone.phoneCode;
    }
  }

  function handlePincodeLookup(pincode) {
    // Only run geo-lookup for India
    if (dom.country.value !== 'IN') return;

    if (pincode.length !== 6) {
      dom.pincodeStatus.textContent = '';
      dom.geoGroup.hidden = true;
      return;
    }

    dom.pincodeStatus.textContent = 'Looking up...';
    dom.pincodeStatus.style.color = 'var(--mc-mist)';

    apiCall('/api/pincode/' + encodeURIComponent(pincode))
      .then(function(data) {
        var city = data.city || data.district || '';
        var stateName = data.state || '';
        dom.city.value = city;
        dom.state.value = stateName;
        dom.pincodeStatus.textContent = '';
        showLocation(stateName, city);
      })
      .catch(function() {
        dom.pincodeStatus.textContent = '';
        dom.geoLabel.textContent = 'Enter manually';
        dom.geoGroup.hidden = true;
        dom.cityStateFields.hidden = false;
      });
  }

  function validateAddressForm() {
    var errors = [];
    var country = dom.country.value;
    var zipRules = ZIP_RULES[country] || ZIP_RULES['DEFAULT'];
    var pincodeVal = dom.pincode.value.trim();

    if (zipRules.required && !pincodeVal) {
      errors.push(zipRules.label + ' is required.');
    }

    if (country === 'IN' && pincodeVal && pincodeVal.length !== 6) {
      errors.push('A valid 6-digit pincode is required.');
    }

    if (country === 'US' && pincodeVal && pincodeVal.length !== 5) {
      errors.push('A valid 5-digit ZIP code is required.');
    }

    if (country === 'SA' && pincodeVal && pincodeVal.length !== 5) {
      errors.push('A valid 5-digit postal code is required.');
    }

    if (!dom.address1.value.trim()) errors.push('Address is required.');
    if (!dom.city.value.trim()) errors.push('City is required.');

    // State: required for India, US, AU; optional for others
    var stateRequired = ['IN', 'US', 'AU'].indexOf(country) !== -1;
    if (stateRequired && !dom.state.value.trim()) errors.push('State is required.');

    if (!dom.fullName.value.trim()) errors.push('Full name is required.');
    if (!dom.email.value.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(dom.email.value.trim())) {
      errors.push('A valid email is required.');
    }

    return errors;
  }

  function handleAddressSave() {
    hideError(dom.addressError);
    var errors = validateAddressForm();

    if (errors.length > 0) {
      showError(dom.addressError, errors[0]);
      return;
    }

    var nameParts = dom.fullName.value.trim().split(/\s+/);
    var firstName = nameParts[0] || '';
    var lastName = nameParts.slice(1).join(' ') || '';

    var payload = {
      first_name: firstName,
      last_name: lastName,
      email: dom.email.value.trim(),
      pincode: dom.pincode.value.trim(),
      address1: dom.address1.value.trim(),
      city: dom.city.value.trim(),
      state: dom.state.value.trim(),
      country_code: dom.country.value,
      label: state.addressLabel || 'Home'
    };

    setButtonLoading(dom.addressSave, true, 'Saving...');

    apiCall('/api/address', {
      method: 'POST',
      body: JSON.stringify(payload)
    })
      .then(function(data) {
        var addressId = data.id || data.addressId || (data.address && data.address.id);
        var savedAddr = Object.assign({}, payload, { id: addressId });
        state.addresses.push(savedAddr);
        state.selectedAddressId = String(addressId);
        setButtonLoading(dom.addressSave, false);

        // Show updated cards and proceed
        renderAddressCards(state.addresses);
        goToStep('address-card');
      })
      .catch(function(err) {
        setButtonLoading(dom.addressSave, false);
        showError(dom.addressError, err.message || 'Failed to save address. Please try again.');
      });
  }

  /* ========================================================================
     Checkout
     ======================================================================== */

  function handleCheckout() {
    if (!state.selectedAddressId) return;

    // Check if selected address is international
    var selectedAddress = null;
    for (var i = 0; i < state.addresses.length; i++) {
      if (String(state.addresses[i].id) === state.selectedAddressId) {
        selectedAddress = state.addresses[i];
        break;
      }
    }

    if (selectedAddress && selectedAddress.country_code && selectedAddress.country_code !== 'IN') {
      state.isInternational = true;
      startInternationalCheckout(selectedAddress);
      return;
    }

    setButtonLoading(dom.checkoutBtn, true, 'Preparing checkout...');

    getCartToken()
      .then(function(cartToken) {
        return apiCall('/api/checkout/prepare', {
          method: 'POST',
          body: JSON.stringify({ addressId: state.selectedAddressId, cartToken: cartToken })
        });
      })
      .then(function(data) {
        if (data.checkoutUrl) {
          window.location.href = data.checkoutUrl;
        } else {
          throw new Error('No checkout URL returned.');
        }
      })
      .catch(function(err) {
        setButtonLoading(dom.checkoutBtn, false);
        // Show a transient error — address step is still visible
        var errorDiv = dom.addressError;
        showError(errorDiv, err.message || 'Failed to prepare checkout. Please try again.');
      });
  }

  /* ========================================================================
     Session Management
     ======================================================================== */

  function validateExistingSession() {
    if (!state.sessionToken) {
      return Promise.resolve(false);
    }

    return apiCall('/api/customer/lookup')
      .then(function(data) {
        state.addresses = data.addresses || [];
        // Update state.phone with full phone from address data (cookie has masked phone)
        var lastAddr = state.addresses.length > 0 ? state.addresses[state.addresses.length - 1] : null;
        if (lastAddr && lastAddr.phone_e164) {
          state.phone = lastAddr.phone_e164;
        }
        return true;
      })
      .catch(function() {
        clearSession();
        return false;
      });
  }

  function clearSession() {
    state.sessionToken = null;
    state.phone = null;
    state.sessionId = null;
    state.selectedAddressId = null;
    state.addresses = [];
    // Clear legacy localStorage
    localStorage.removeItem('mc_session_token');
    localStorage.removeItem('mc_session_phone');
    // Clear httpOnly + info cookies via API (JS can't clear httpOnly cookies directly)
    fetch(API + '/api/session/logout', { method: 'POST', credentials: 'include' }).catch(function() {});
  }

  function handleLogout() {
    clearSession();
    dom.sessionInfo.hidden = true;
    dom.checkoutBtn.hidden = true;
    goToStep('phone');
  }

  /* ========================================================================
     Back Button
     ======================================================================== */

  function handleBack() {
    if (state.currentStep === 'phone') {
      closePopup();
      return;
    }

    // International steps: back from cart summary → address card
    if (state.currentStep === 'intl-cart') {
      state.isInternational = false;
      renderAddressCards(state.addresses);
      goToStep('address-card');
      return;
    }

    // Cannot go back during processing
    if (state.currentStep === 'intl-processing') {
      return;
    }

    // From confirmation → close popup and go to order status or home
    if (state.currentStep === 'intl-confirmed') {
      closePopup();
      if (state.intlOrderStatusUrl) {
        window.location.href = state.intlOrderStatusUrl;
      } else {
        window.location.href = '/';
      }
      return;
    }

    // From address card → close popup (logged-in user's first screen)
    if (state.currentStep === 'address-card') {
      closePopup();
      return;
    }

    // From address form → go back to card list if we have saved addresses
    if (state.currentStep === 'address' && state.sessionToken && state.addresses.length > 0) {
      renderAddressCards(state.addresses);
      goToStep('address-card');
      return;
    }

    var currentIndex = STEP_ORDER.indexOf(state.currentStep);

    if (currentIndex > 0) {
      var prevStep = STEP_ORDER[currentIndex - 1];

      // Skip OTP if going back from address with active session
      if (prevStep === 'otp' && state.sessionToken) {
        goToStep('phone');
        return;
      }

      goToStep(prevStep);
    }
  }

  /* ========================================================================
     Checkout Interception
     ======================================================================== */

  function initInterception() {
    // Primary: intercept clicks on checkout buttons (fires before other handlers)
    document.addEventListener('click', function(e) {
      var target = e.target;

      // Checkout buttons: <button name="checkout"> or elements inside it
      var checkoutBtn = target.closest('button[name="checkout"], input[name="checkout"]');
      if (checkoutBtn) {
        e.preventDefault();
        e.stopImmediatePropagation();
        handleCheckoutIntercept(checkoutBtn);
        return;
      }

      // Buy It Now / dynamic checkout buttons
      var buyNow = target.closest('.shopify-payment-button');
      if (buyNow) {
        e.preventDefault();
        e.stopImmediatePropagation();
        var buyNowBtn = buyNow.querySelector('button') || buyNow;
        handleCheckoutIntercept(buyNowBtn);
        return;
      }

      // Direct links to /checkout
      var link = target.closest('a[href*="/checkout"]');
      if (link) {
        e.preventDefault();
        e.stopImmediatePropagation();
        handleCheckoutIntercept(link);
        return;
      }
    }, true);

    // Fallback: intercept form submissions to /checkout
    document.addEventListener('submit', function(e) {
      var form = e.target;
      if (!form) return;

      var action = form.getAttribute('action') || '';
      var hasCheckoutBtn = form.querySelector('button[name="checkout"], input[name="checkout"]');

      if (hasCheckoutBtn) {
        e.preventDefault();
        e.stopImmediatePropagation();
        handleCheckoutIntercept(hasCheckoutBtn);
        return;
      }

      if (action.indexOf('/checkout') !== -1) {
        e.preventDefault();
        e.stopImmediatePropagation();
        handleCheckoutIntercept(form.querySelector('button[type="submit"]'));
      }
    }, true);
  }

  /* ========================================================================
     Event Binding
     ======================================================================== */

  function bindEvents() {
    // Close
    dom.backdrop.addEventListener('click', closePopup);

    // Escape key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && !dom.popup.hidden) {
        closePopup();
      }
    });

    // Back
    dom.backBtn.addEventListener('click', handleBack);

    // Phone step
    dom.countryCode.addEventListener('change', function() {
      state.countryCode = dom.countryCode.value;
      var maxLengths = { '+91': 10, '+1': 11, '+44': 11 };
      dom.phoneInput.maxLength = maxLengths[state.countryCode] || 15;
    });

    // Address country dropdown
    dom.country.addEventListener('change', function() {
      updateFormForCountry(dom.country.value);
    });

    dom.phoneInput.addEventListener('input', function() {
      // Strip non-digits
      var raw = dom.phoneInput.value.replace(/\D/g, '');
      dom.phoneInput.value = raw;

      // Block leading zero (for Indian numbers)
      if (state.countryCode === '+91' && raw.length > 0 && raw[0] === '0') {
        showError(dom.phoneError, 'Mobile numbers don\u2019t start with 0. Try without it.');
        return;
      }

      hideError(dom.phoneError);

      // Auto-advance when 10 valid digits entered
      if (state.countryCode === '+91' && raw.length === 10 && validatePhone(raw)) {
        handlePhoneSubmit();
      }
    });

    dom.phoneInput.addEventListener('keydown', function(e) {
      if (e.key === 'Enter') {
        handlePhoneSubmit();
      }
    });

    dom.phoneSubmit.addEventListener('click', handlePhoneSubmit);

    // OTP step
    dom.otpSubmit.addEventListener('click', handleOTPSubmit);

    dom.resendBtn.addEventListener('click', function() {
      if (!dom.resendBtn.disabled) {
        handleResend();
      }
    });

    dom.editPhoneBtn.addEventListener('click', function() {
      clearCooldown('sms');
      clearCooldown('whatsapp');
      goToStep('phone');
      dom.phoneInput.focus();
    });

    dom.whatsappBtn.addEventListener('click', handleWhatsAppSend);

    // Last OTP digit enter triggers submit
    dom.otpDigits[dom.otpDigits.length - 1].addEventListener('input', function() {
      var code = getOTPValue();
      if (code.length === 6) {
        // Small delay to let the UI update
        setTimeout(handleOTPSubmit, 100);
      }
    });

    // Address step
    dom.addressSave.addEventListener('click', handleAddressSave);

    // Pincode lookup on blur (only triggers for India)
    dom.pincode.addEventListener('blur', function() {
      if (dom.country.value === 'IN') {
        handlePincodeLookup(dom.pincode.value.trim());
      }
    });

    // Also trigger pincode lookup when correct length entered
    dom.pincode.addEventListener('input', function() {
      var country = dom.country.value;
      var rules = ZIP_RULES[country] || ZIP_RULES['DEFAULT'];

      // Strip non-digits only for numeric inputmode countries
      if (rules.inputmode === 'numeric') {
        dom.pincode.value = dom.pincode.value.replace(/\D/g, '');
      }

      var val = dom.pincode.value.trim();
      if (country === 'IN' && val.length === 6) {
        handlePincodeLookup(val);
      }
    });

    // Location selector click to edit city/state manually
    dom.addressGeo.addEventListener('click', function() {
      dom.geoGroup.hidden = true;
      dom.cityStateFields.hidden = false;
      dom.state.focus();
    });

    // Save-as tags
    dom.saveTags.addEventListener('click', function(e) {
      var tag = e.target.closest('.mc-tag');
      if (tag) {
        setActiveTag(tag.dataset.tag);
      }
    });

    // Address form enter key
    dom.stepAddress.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' && e.target.tagName === 'INPUT') {
        e.preventDefault();
        handleAddressSave();
      }
    });

    // Address card list — click to select, edit button to edit
    dom.addrList.addEventListener('click', function(e) {
      var editBtn = e.target.closest('.mc-addr-card__edit');
      if (editBtn) {
        var idx = parseInt(editBtn.dataset.editIndex, 10);
        handleCardEdit(idx);
        return;
      }
      var card = e.target.closest('.mc-addr-card');
      if (card && card.dataset.addressId) {
        selectAddressCard(card.dataset.addressId);
      }
    });

    // Add new address button
    dom.addrAddBtn.addEventListener('click', function() {
      goToStep('address');
      prefillAddressForm([]);
    });

    dom.cardCheckout.addEventListener('click', handleCardCheckout);

    // Checkout (footer button, kept for potential use)
    dom.checkoutBtn.addEventListener('click', handleCheckout);

    // International checkout
    dom.intlPayBtn.addEventListener('click', handleIntlPayment);

    dom.intlContinueBtn.addEventListener('click', function() {
      closePopup();
      if (state.intlOrderStatusUrl) {
        window.location.href = state.intlOrderStatusUrl;
      } else {
        window.location.href = '/';
      }
    });

    // Logout
    dom.logoutBtn.addEventListener('click', handleLogout);

  }

  /* ========================================================================
     International Checkout
     ======================================================================== */

  function clearIntlPollingTimer() {
    if (state.intlPollingTimer) {
      clearInterval(state.intlPollingTimer);
      state.intlPollingTimer = null;
    }
  }

  var razorpayScriptLoaded = false;
  function loadRazorpayScript() {
    return new Promise(function(resolve, reject) {
      if (razorpayScriptLoaded || typeof Razorpay !== 'undefined') {
        razorpayScriptLoaded = true;
        resolve();
        return;
      }
      var script = document.createElement('script');
      script.src = 'https://checkout.razorpay.com/v1/checkout.js';
      script.onload = function() {
        razorpayScriptLoaded = true;
        resolve();
      };
      script.onerror = function() {
        reject(new Error('Failed to load Razorpay'));
      };
      document.head.appendChild(script);
    });
  }

  function formatIntlPrice(amount, currency) {
    var num = typeof amount === 'number' ? amount : parseFloat(amount) || 0;
    return currency + ' ' + num.toFixed(2);
  }

  function startInternationalCheckout(address) {
    setButtonLoading(dom.cardCheckout, true, 'Loading prices...');

    loadRazorpayScript()
      .catch(function() {
        // Non-blocking: Razorpay will be checked again before payment
      })
      .then(function() { return fetch('/cart.js'); })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var items = cart.items.map(function(item) {
          return {
            variantId: item.variant_id,
            quantity: item.quantity,
            productTitle: item.product_title,
            variantTitle: item.variant_title || '',
            image: item.featured_image ? item.featured_image.url : '',
            finalLinePrice: item.final_line_price,
            originalLinePrice: item.original_line_price,
            totalDiscount: item.total_discount || 0
          };
        });

        var countryCode = address.country_code || '';
        var shippingAddress = {
          first_name: address.first_name || '',
          last_name: address.last_name || '',
          address1: address.address1 || '',
          city: address.city || '',
          state: address.state || '',
          zip: address.pincode || address.zip || '',
          country_code: countryCode,
          email: address.email || '',
          phone: address.phone_e164 || state.phone || ''
        };

        // Store original cart items before API call (for create-rz-order discount forwarding)
        state.intlCartOriginalItems = items;

        return apiCall('/api/intl/cart-pricing', {
          method: 'POST',
          body: JSON.stringify({
            items: items,
            countryCode: countryCode,
            shippingAddress: shippingAddress
          })
        });
      })
      .then(function(response) {
        setButtonLoading(dom.cardCheckout, false);
        state.intlCart = response.data;
        renderIntlCart(response.data);
        goToStep('intl-cart');
      })
      .catch(function(err) {
        setButtonLoading(dom.cardCheckout, false);
        showError(dom.cardError, err.message || 'Failed to load international pricing. Please try again.');
      });
  }

  function renderIntlCart(cartData) {
    var currency = cartData.currency || 'USD';
    var items = cartData.items || [];
    var subtotal = cartData.subtotal || 0;
    var shipping = cartData.shipping || 0;
    var total = cartData.total || 0;

    // Update currency label
    dom.intlCurrencyLabel.textContent = 'Prices in ' + escapeHtml(currency);

    // Render items
    var html = items.map(function(item) {
      var imgSrc = item.image ? item.image + '&width=120' : '';
      var title = item.productTitle || item.title || '';
      var variant = item.variantTitle || '';
      var qty = item.quantity || 1;
      var lineTotal = item.lineTotal || 0;

      return '<div class="mc-intl-cart__item">' +
        (imgSrc ? '<img src="' + escapeAttr(imgSrc) + '" alt="" class="mc-intl-cart__item-img">' : '') +
        '<div class="mc-intl-cart__item-info">' +
          '<div class="mc-intl-cart__item-title">' + escapeHtml(title) + '</div>' +
          (variant ? '<div class="mc-intl-cart__item-variant">' + escapeHtml(variant) + '</div>' : '') +
          '<div class="mc-intl-cart__item-qty">Qty: ' + qty + '</div>' +
        '</div>' +
        '<div class="mc-intl-cart__item-price">' + escapeHtml(formatIntlPrice(lineTotal, currency)) + '</div>' +
      '</div>';
    }).join('');

    dom.intlCartItems.innerHTML = html;

    // Update totals
    dom.intlSubtotal.textContent = formatIntlPrice(subtotal, currency);
    dom.intlShipping.textContent = shipping > 0 ? formatIntlPrice(shipping, currency) : 'Free';
    dom.intlTotal.textContent = formatIntlPrice(total, currency);
    dom.intlPayAmount.textContent = formatIntlPrice(total, currency);
  }

  function handleIntlPayment() {
    if (typeof Razorpay === 'undefined') {
      showIntlError('Payment gateway not loaded. Please refresh and try again.');
      return;
    }

    dom.intlPayBtn.classList.add('mc-btn-loading');
    dom.intlPayBtn.disabled = true;

    var selectedAddress = null;
    for (var i = 0; i < state.addresses.length; i++) {
      if (String(state.addresses[i].id) === state.selectedAddressId) {
        selectedAddress = state.addresses[i];
        break;
      }
    }

    // Use original cart items which have finalLinePrice from Shopify cart
    var items = (state.intlCartOriginalItems || state.intlCart.items).map(function(item) {
      return { variantId: item.variantId, quantity: item.quantity, finalLinePrice: item.finalLinePrice, originalLinePrice: item.originalLinePrice, totalDiscount: item.totalDiscount || 0 };
    });

    apiCall('/api/intl/create-rz-order', {
      method: 'POST',
      body: JSON.stringify({
        items: items,
        countryCode: selectedAddress ? selectedAddress.country_code : '',
        shippingAddress: {
          firstName: selectedAddress ? (selectedAddress.first_name || '') : '',
          lastName: selectedAddress ? (selectedAddress.last_name || '') : '',
          address1: selectedAddress ? (selectedAddress.address1 || '') : '',
          city: selectedAddress ? (selectedAddress.city || '') : '',
          province: selectedAddress ? (selectedAddress.state || '') : '',
          country: selectedAddress ? (selectedAddress.country_code || '') : '',
          zip: selectedAddress ? (selectedAddress.pincode || '') : '',
          phone: selectedAddress ? (selectedAddress.phone || state.countryCode + state.phone) : (state.countryCode + state.phone)
        },
        customerEmail: selectedAddress ? (selectedAddress.email || '') : '',
        customerName: selectedAddress ? ((selectedAddress.first_name || '') + ' ' + (selectedAddress.last_name || '')).trim() : ''
      })
    })
      .then(function(response) {
        var data = response.data;
        dom.intlPayBtn.classList.remove('mc-btn-loading');
        dom.intlPayBtn.disabled = false;

        var options = {
          key: data.razorpayKeyId,
          amount: data.amount,
          currency: data.currency || state.intlCart.currency,
          name: 'Macmerise',
          description: 'International Order',
          order_id: data.razorpayOrderId,
          handler: function(response) {
            state.intlRzOrderId = data.razorpayOrderId;
            goToStep('intl-processing');
            startOrderPolling();
          },
          modal: {
            ondismiss: function() {
              dom.intlPayBtn.classList.remove('mc-btn-loading');
              dom.intlPayBtn.disabled = false;
            }
          },
          prefill: {
            contact: selectedAddress ? (selectedAddress.phone_e164 || state.phone || '') : (state.phone || ''),
            email: selectedAddress ? (selectedAddress.email || '') : ''
          },
          theme: {
            color: '#D97757'
          }
        };

        var rzp = new Razorpay(options);
        rzp.open();
      })
      .catch(function(err) {
        dom.intlPayBtn.classList.remove('mc-btn-loading');
        dom.intlPayBtn.disabled = false;
        showIntlError(err.message || 'Failed to initiate payment. Please try again.');
      });
  }

  function startOrderPolling() {
    var attempts = 0;
    var maxAttempts = 15;
    var errorCount = 0;

    state.intlPollingTimer = setInterval(function() {
      attempts++;

      apiCall('/api/intl/order-status?razorpayOrderId=' + encodeURIComponent(state.intlRzOrderId))
        .then(function(response) {
          var result = response.data;
          errorCount = 0;
          if (result.status === 'completed') {
            clearIntlPollingTimer();
            showOrderConfirmation(result);
          } else if (result.status === 'failed') {
            clearIntlPollingTimer();
            showIntlError('Order processing failed. You will be refunded.');
          }
        })
        .catch(function() {
          errorCount++;
          if (errorCount >= 3 && dom.intlProcessingText) {
            dom.intlProcessingText.textContent = 'Having trouble reaching our servers. Your payment is safe \u2014 we will email you confirmation.';
          }
        });

      if (attempts >= maxAttempts) {
        clearIntlPollingTimer();
        showOrderProcessingMessage();
      }
    }, 2000);
  }

  function showOrderConfirmation(data) {
    dom.intlOrderName.textContent = escapeHtml(data.shopifyOrderName || data.orderName || '');

    // Clear the Shopify cart after successful order
    clearShopifyCart();

    // Store order status URL for redirect
    state.intlOrderStatusUrl = data.orderStatusUrl || null;

    goToStep('intl-confirmed');
  }

  function clearShopifyCart() {
    fetch('/cart/clear.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' }
    })
    .then(function() {
      // Update cart count in header
      var cartCounts = document.querySelectorAll('.cart-count, [data-cart-count], .js-cart-count');
      cartCounts.forEach(function(el) { el.textContent = '0'; });

      // Dispatch cart update event for theme JS
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    })
    .catch(function() {
      // Silent fail — cart will be stale but order is placed
    });
  }

  function showOrderProcessingMessage() {
    dom.intlProcessingText.textContent = 'Your order is being processed. You\'ll receive a confirmation email shortly.';
  }

  function showIntlError(message) {
    // Re-use the card error element if on cart step, or show on processing step
    if (state.currentStep === 'intl-cart') {
      // Create a temporary error element if not present
      var existingErr = dom.stepIntlCart.querySelector('.mc-error');
      if (!existingErr) {
        existingErr = document.createElement('div');
        existingErr.className = 'mc-error';
        existingErr.setAttribute('role', 'alert');
        dom.intlPayBtn.parentNode.insertBefore(existingErr, dom.intlPayBtn);
      }
      showError(existingErr, message);
    } else if (state.currentStep === 'intl-processing') {
      // Show error on the processing step by switching to confirmation with error
      dom.intlProcessingText.textContent = message;
    } else {
      showError(dom.cardError, message);
    }
  }

  /* ========================================================================
     Utilities
     ======================================================================== */

  function escapeHtml(str) {
    if (!str) return '';
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(str));
    return div.innerHTML;
  }

  function escapeAttr(str) {
    if (!str) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  /* ========================================================================
     Initialize
     ======================================================================== */

  function init() {
    // Bail if popup element doesn't exist (section disabled)
    if (!document.getElementById('mc-checkout-popup')) return;

    cacheDom();

    // "…sent on WhatsApp to +91 …" wraps: keep the number and its edit pencil
    // together so the break falls before the number, never inside it.
    var sentTo = document.createElement('span');
    sentTo.className = 'mc-otp-sent-to';
    dom.otpPhoneDisplay.parentNode.insertBefore(sentTo, dom.otpPhoneDisplay);
    sentTo.appendChild(dom.otpPhoneDisplay);
    sentTo.appendChild(dom.editPhoneBtn);

    initOTPInputs();
    initOrderToggle();
    bindEvents();
    initInterception();
    document.addEventListener('keydown', trapFocus);

    // Expose state so account dropdown can sync session after inline login
    window.__mcCheckoutState = state;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
